module.exports = __webpack_public_path__ + "static/img/1-3.ab36c08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/1-3.png
// module id = 5rMP
// module chunks = 1